'use client';
import { ComponentType } from 'react';
import { useTranslations } from 'next-intl';
import {
  CatButton,
  CatTextPassage,
  CatTooltip
} from 'components/blocks-components';
import { useDrawer } from 'components/pcc-components';
import FitmentContent from 'components/fitment-content';
import FitmentTitle from 'components/fitment-title';
import FitmentMobileDrawer from './fitment-mobile-drawer/fitment-mobile-drawer';
import styles from './fitment-wrapper.module.scss';
import cx from 'classnames';

type FitmentWrapperProps = {
  altTagTitle: string;
  icon: ComponentType;
  iconColor: string;
  model: string;
  productFamily: string;
  serialNumber: string;
  fitmentDisplayText: string;
  popupText: string;
  popupMessage: string;
  isFitmentMobile?: boolean;
  isTooltipMobileDrawer?: boolean;
};

const FitmentWrapper = ({
  altTagTitle,
  icon,
  iconColor,
  model,
  productFamily,
  serialNumber,
  fitmentDisplayText,
  popupText,
  popupMessage,
  isFitmentMobile,
  isTooltipMobileDrawer = false
}: FitmentWrapperProps) => {
  const t = useTranslations();
  const { drawerProps, openDrawer, closeDrawer } = useDrawer();
  const mobileDrawerProps = { ...drawerProps, closeDrawer };

  const fitmentTitle = (
    <FitmentTitle
      modelText={model}
      equipmentFamilyText={productFamily}
      serialNumberText={serialNumber}
      fitmentDisplayText={t(fitmentDisplayText)}
      isFitmentMobile={isFitmentMobile}
    />
  );

  const popupContent = [
    {
      text: t(popupMessage),
      className: 'cat-u-theme-typography-label mb-1'
    },
    {
      text: t(popupText),
      className: 'cat-u-theme-typography-body-sm mb-0'
    }
  ];

  const getPopupContent = () => {
    return (
      Array.isArray(popupContent) &&
      popupContent.map((item) => (
        <p className={`${item.className}`} key={item.text}>
          {item.text}
        </p>
      ))
    );
  };

  const renderTriggetButton = (isMobileDrawerTrigger = false) => (
    <CatButton
      variant="ghost"
      className={styles['fitment-content__btn']}
      data-testid="trigger-button"
      title={altTagTitle}
      {...(isMobileDrawerTrigger
        ? { onClick: openDrawer }
        : { slot: 'trigger' })}
    >
      <FitmentContent
        icon={icon}
        iconColor={iconColor}
        buttonTitle={fitmentTitle}
        isFitmentMobile={isFitmentMobile}
      />
    </CatButton>
  );
  return (
    <>
      {isTooltipMobileDrawer ? (
        <>
          <div className="d-block d-md-none">
            {renderTriggetButton(true)}
            <FitmentMobileDrawer
              subtitle={t(popupMessage)}
              content={t(popupText)}
              drawerProps={mobileDrawerProps}
            />
          </div>
          <CatTooltip
            className={cx(styles['fitment-tooltip'], 'd-none d-md-block')}
            position="bottom"
            isInteractive
          >
            {renderTriggetButton()}
            <CatTextPassage size="xs">{getPopupContent()}</CatTextPassage>
          </CatTooltip>
        </>
      ) : (
        <CatTooltip
          className={styles['fitment-tooltip']}
          position="bottom"
          isInteractive
        >
          {renderTriggetButton()}
          <CatTextPassage size="xs">{getPopupContent()}</CatTextPassage>
        </CatTooltip>
      )}
    </>
  );
};

export default FitmentWrapper;
